import { Component } from '@angular/core';

@Component({
    selector: 'app-blank',
    templateUrl: './blank.component.html',
    styleUrls: [],
    standalone: false
})
export class AppBlankComponent {}
